var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-toolbar",
            {
              staticStyle: { "padding-top": "50px" },
              attrs: { dense: "", extended: "", color: "primary", dark: "" },
            },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", "pa-5": "" } },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass: "display-2",
                      attrs: { slot: "extension" },
                      slot: "extension",
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "padding-bottom": "10px" },
                          attrs: { "x-large": "" },
                        },
                        [_vm._v("add_a_photo")]
                      ),
                      _vm._v("\n          Station Photo Upload\n        "),
                    ],
                    1
                  ),
                  _vm._v(
                    "\n        Upload photos to station photo configurations.\n        "
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mt-2",
                      attrs: {
                        flat: "",
                        dark: "",
                        to: { name: "ingestionDashboard" },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("arrow_back"),
                      ]),
                      _vm._v("Back to Dashboard\n        "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", md8: "", "offset-md2": "", "pa-3": "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                { staticClass: "pt-3" },
                [
                  _c(
                    "v-form",
                    { ref: "form", attrs: { "lazy-validation": "" } },
                    [
                      _c("v-select", {
                        attrs: {
                          label: "Station Photo Configuration",
                          items: _vm.photoStationIds,
                          "item-text": "text",
                          "item-value": "value",
                          rules: [_vm.rules.required],
                          required: "",
                          hint: _vm.photoConfigsLoaded
                            ? "Select an active StationPhotos configuration"
                            : "No active StationPhotos configurations found. Create one first.",
                          "persistent-hint": !_vm.photoConfigsLoaded,
                        },
                        model: {
                          value: _vm.selectedStation,
                          callback: function ($$v) {
                            _vm.selectedStation = $$v
                          },
                          expression: "selectedStation",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          label: "Job ID (optional)",
                          placeholder: "Leave empty to auto-generate",
                          hint: "UUID to correlate with previous uploads",
                        },
                        model: {
                          value: _vm.jobId,
                          callback: function ($$v) {
                            _vm.jobId = $$v
                          },
                          expression: "jobId",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "", "align-center": "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "" } },
                            [
                              _c("input", {
                                ref: "fileInput",
                                staticStyle: { display: "none" },
                                attrs: {
                                  type: "file",
                                  multiple: "",
                                  accept:
                                    ".jpg,.jpeg,.png,.gif,.bmp,.tiff,.tif",
                                },
                                on: { change: _vm.onFilesSelected },
                              }),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    disabled: !_vm.selectedStation,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$refs.fileInput.click()
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { left: "" } }, [
                                    _vm._v("attach_file"),
                                  ]),
                                  _vm._v("Select Photos\n              "),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs12: "", sm6: "" } }, [
                            _vm.selectedFiles.length > 0
                              ? _c("span", { staticClass: "body-2" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.selectedFiles.length) +
                                      " file(s) selected\n              "
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.previews.length > 0
                        ? _c(
                            "v-layout",
                            {
                              staticClass: "mt-3",
                              attrs: { row: "", wrap: "" },
                            },
                            _vm._l(_vm.previews, function (p, i) {
                              return _c(
                                "v-flex",
                                {
                                  key: i,
                                  attrs: {
                                    xs4: "",
                                    sm3: "",
                                    md2: "",
                                    "pa-1": "",
                                  },
                                },
                                [
                                  _c(
                                    "v-card",
                                    [
                                      _c("v-img", {
                                        attrs: {
                                          src: p,
                                          height: "80",
                                          contain: "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "v-card-text",
                                        {
                                          staticClass:
                                            "caption pa-1 text-xs-center",
                                        },
                                        [_vm._v(_vm._s(_vm.fileNames[i]))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.uploading
                        ? _c("v-progress-linear", {
                            staticClass: "mt-3",
                            attrs: { indeterminate: "" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mt-3",
                          attrs: {
                            block: "",
                            large: "",
                            color: "success",
                            dark: "",
                            disabled:
                              !_vm.selectedStation ||
                              _vm.selectedFiles.length === 0 ||
                              _vm.uploading,
                          },
                          on: { click: _vm.doUpload },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("cloud_upload"),
                          ]),
                          _vm._v("Upload Photos\n          "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.result
                ? _c(
                    "v-card-text",
                    [
                      _c("v-divider", { staticClass: "mb-3" }),
                      _vm._v(" "),
                      _c("v-subheader", [_vm._v("Upload Results")]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs4: "" } },
                            [
                              _c(
                                "v-chip",
                                { attrs: { color: "success", dark: "" } },
                                [
                                  _vm._v(
                                    "Uploaded: " +
                                      _vm._s(_vm.result.uploadedCount)
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "" } },
                            [
                              _c(
                                "v-chip",
                                { attrs: { color: "warning", dark: "" } },
                                [
                                  _vm._v(
                                    "Skipped: " +
                                      _vm._s(_vm.result.skippedCount)
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "" } },
                            [
                              _c(
                                "v-chip",
                                { attrs: { color: "error", dark: "" } },
                                [
                                  _vm._v(
                                    "Failed: " + _vm._s(_vm.result.failedCount)
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.result.details && _vm.result.details.length > 0
                        ? _c("v-data-table", {
                            staticClass: "mt-2",
                            attrs: {
                              headers: _vm.detailHeaders,
                              items: _vm.result.details,
                              "hide-actions": "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "items",
                                  fn: function (props) {
                                    return [
                                      _c("td", [
                                        _vm._v(_vm._s(props.item.fileName)),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _c(
                                            "v-chip",
                                            {
                                              attrs: {
                                                color: _vm.detailStatusColor(
                                                  props.item.status
                                                ),
                                                small: "",
                                                dark: "",
                                              },
                                            },
                                            [_vm._v(_vm._s(props.item.status))]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            props.item.errorMessage ||
                                              (props.item.blobUrl
                                                ? props.item.blobUrl.substring(
                                                    0,
                                                    60
                                                  ) + "..."
                                                : "-")
                                          )
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3008986017
                            ),
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mt-2",
                          attrs: { color: "primary" },
                          on: { click: _vm.resetForm },
                        },
                        [_vm._v("Upload More")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { color: _vm.snackColor, timeout: 6000, top: "" },
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.snackMessage) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              on: {
                click: function ($event) {
                  _vm.snackbar = false
                },
              },
            },
            [_vm._v("Close")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }